export class PvhPoItemVariant {

    line: string;
    plmStyle: string;
    size: string;
    dimensions: string;
    sizeDescription: string;
    color: string;
    upc: string;
    quantity: string;
    unitPrice: string;
   
}